import { ESFieldMappingDefinition } from 'modules/workflows/types';

export const filterCustomEvents = (events: ESFieldMappingDefinition[]) => {
  return events.filter((event) => {
    if (event?.isHidden === true) return false;
    if (event?.isAllowed === false) return false;
    return true;
  });
};
